<template>
    <v-layout row wrap>
        <v-dialog v-model="dialogpickitem" persistent max-width="490">
            <v-card>
                <v-card-title class="headline primary white--text">
                    {{ $t('Markup-Added-per-Person') }}
                    <v-spacer></v-spacer>

                </v-card-title>
                <v-card-text>
                    <v-text-field outline :label="$t('Markup-Added-per-Person')" v-model="ticketMarkup"
                        @keyup.enter="selectFlight()">
                    </v-text-field>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat @click="dialogpickitem = false">{{
                        $t("Cancel")
                    }}

                    </v-btn>

                    <v-btn color="primary" flat @click="selectFlight()">{{
                        $t("Continue")
                    }}
                        <v-icon right>send</v-icon>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <loadingcomp v-bind:mesaj="''" v-model="loadingvmodel"></loadingcomp>
        <snackbarcomp v-bind:mesaj="text1" v-model="snackbar" v-bind:color="snackbarkColor"></snackbarcomp>
        <SelectFlight :flights="flights" :step="1" :selectedFlight="selectedFlight" @clearFlight="clearGidis"
            :FlightType="'RT'" @selectFlight="pickFlight" @toggle-loading="toggleLoading"
            @toggle-snackbar="toggleSnackbar" :currency="currency" />
    </v-layout>
</template>
<script>
import { select } from 'underscore';
import SelectFlight from '../comp/SelectFlightNew.vue';
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import Airports from "../../../ucak/airports.js";

export default {
    name: "RT",
    data() {
        return {
            selectedFlight: null,
            selectedFareCode: "",
            loadingvmodel: false,
            snackbar: false,
            text1: "",
            snackbarkColor: "error",
            allocated: Airports.allocateParams(),
            allocateItems: Airports.allocateItems(),
            dialogpickitem: false,
        };
    },
    components: {
        SelectFlight,
        loadingcomp,
        snackbarcomp
    },
    props: {
        flights: {
            type: Array,
            required: true,
        },
        ticketMarkup: {
            type: Number,
            required: true,
        },
        FlightType: {
            type: String,
            required: true,
        },
        currency: {
            type: String,
            default: 'TRY',
        },
    },
    methods: {
        toggleSnackbar(val, msg, color) {
            this.snackbar = val;
            this.text1 = msg;
            this.snackbarkColor = color;
        },
        clearGidis() {
            this.selectedFlight = null;
        },
        pickFlight(flight, fare) {
            this.selectedFlight = flight;
            this.selectedFareCode = fare;
            this.dialogpickitem = true;
        },
        async selectFlight() {
            await this.checkTurna(this.selectedFlight);
            await this.prepareAllocateParams(this.selectedFlight);
            var url = "#/satis/ucus/islem/id?islem=new";
            window.open(url, "_self");
        },
        toggleLoading(val) {
            this.loadingvmodel = val;
        },
        async prepareAllocateParams() {
            let bookingParams = JSON.parse(
                window.localStorage.getItem("bookingParams")
            );
            this.allocated.SessionHeader.SessionId = bookingParams.SessionId;
            this.allocated.SessionHeader.SessionToken = bookingParams.SessionToken;
            if (this.selectedFlight.FlightSegments.length > 1) {
                var reffare = this.selectedFareCode;

                //  FareCode: reffare,
                let allocateFirstParams = {
                    ProductId: this.selectedFlight.Id,
                    FareCode: reffare,
                    MarkupFare: this.ticketMarkup,
                    SetServiceFare: 0,
                };
                this.allocated.AllocateItems.push(allocateFirstParams);


            } else {
                this.allocateItems.ProductId = this.selectedFlight.Id;
                this.allocateItems.FareCode = this.selectedFareCode;//this.selectedFlight.pricinginfo.FareReferenceId;
                this.allocateItems.MarkupFare = this.ticketMarkup;
                this.allocated.AllocateItems.push(this.allocateItems);
            }
            window.localStorage.setItem("flightType", this.FlightType);
            window.localStorage.setItem(
                "allocateParams",
                JSON.stringify(this.allocated)
            );
        },
        async checkTurna(ticket) {
            var isTurna =
                ticket &&
                ticket.FlightSegments &&
                ticket.FlightSegments.length > 0 &&
                ticket.FlightSegments[0] &&
                ticket.FlightSegments[0].Provider === "Turna";

            if (isTurna) {
                const hasTurna = await this.getProvidersTurna();

                if (!hasTurna) {
                    this.text1 = "Bilet Kesim ve Rezervasyon İşlemi İçin Turna Acente Kodu Belirtilmeli";
                    this.snackbar = true;
                    return false;
                }
            }
            return true;
        },
        async getProvidersTurna() {
            try {
                var bookingParams = JSON.parse(
                    window.localStorage.getItem("bookingParams")
                );

                var params = {
                    SessionHeader: {
                        SessionId: bookingParams.SessionId,
                        SessionToken: bookingParams.SessionToken
                    }
                };

                const response = await this.$http.post(
                    auth.BOOKING_API_URL + "Agency/GetCredential",
                    params,
                    {
                        headers: {
                            Authorization: "Bearer " + auth.getAuthHeader(),
                        },
                    }
                );

                const rsp = response.body.Credentials;

                const turnaProvider = rsp.find(x =>
                    x.ProviderType === "Air" &&
                    x.Provider === "Turna" &&
                    x.OfficeId &&
                    x.OfficeId !== ""
                );

                return !!turnaProvider;

            } catch (error) {
                this.text1 = "GetCredential - Service Unavailable";
                this.loadingvmodel = false;
                this.snackbar = true;
                return false;
            }
        },
    }
};
</script>